import "./cookie-banner.scss";
import React from "react";
import { Link } from "gatsby";

const CookieBanner = ({ onClick }) => {
   return (
      <div className="cookie-banner">
         <div className="container cookie-banner__container">
            <div className="cookie-banner__wrapper">
               Ta strona korzysta z plików cookies. Wchodząc na nią, zgadzasz
               się korzystanie z plików cookies. Ustawienia cookies możesz
               zmienić w swojej przeglądarce.{" "}
               <Link to="/polityka-cookies">Polityka cookies</Link>
            </div>
            <button
               type="button"
               className="button cookie-banner__button"
               onClick={onClick}
            >
               Zgadzam się
            </button>
         </div>
      </div>
   );
};

export default CookieBanner;
